
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lausnir/opinberir-adilar",
      function () {
        return require("private-next-pages/lausnir/opinberir-adilar.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lausnir/opinberir-adilar"])
      });
    }
  